import { AssetTypes } from "@zapier/utils";
import { trpc } from "../trpc";

interface Input {
  folderId?: string | null; // used for cache invalidation
}

export function useMoveAssetsToFolder(input?: Input) {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  const { mutate: moveAssetsToFolder, isPending } =
    trpc.asset.moveToFolder.useMutation({
      onSettled: (variables) => {
        const { movedAssets } = variables || {};
        const assetType: AssetTypes = movedAssets?.[0]?.type as AssetTypes;

        if (folderId) {
          utils.asset.getHydratedFolderAssets.invalidate({ folderId });
        }

        if (assetType === AssetTypes.Zap) {
          utils.zap.organizationZaps.invalidate();
          utils.zap.storageZaps.invalidate();
        } else {
          utils.folder.foldersLookup.invalidate();
        }
        // Keep folder-subtree copy previews fresh after asset moves.
        utils.folder.listAssetsInFolderSubtree.invalidate();
      },
    });

  return {
    moveAssetsToFolder,
    isPending,
  };
}
